import styled from "styled-components";
import media from "styled-media-query";

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  width: 100vw;
  background: linear-gradient(180deg, rgba(24, 183, 239, 0.4) 0%, #144BC8 100%);
  color: ${({ theme }) => theme.palette.neutral.lightest};

  div.content {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 34px 0;
    ${media.lessThan('1366px')`
      padding: 20px 0;
    `}
    img {
      cursor: pointer;
      height: 46px;
      ${media.lessThan('1366px')`
        height: 36px;
      `}
    }
  }

  ${media.lessThan('1024px')`
    background: linear-gradient(180deg, rgba(24, 183, 239) 0%, #48C8C7 100%);
  `}
`;
